import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'
import { pxToRem } from '#commerce/utils/pxToRem'

export default {
  brandStyles: {
    containerFullHeight: () => (height, fallback) => ({
      h: {
        sm: `calc(100svh - ${height ? pxToRem(height) : fallback?.sm || 0})`,
        lg: `calc(100svh - ${height ? pxToRem(height) : fallback?.lg || 0})`
      }
    })
  },
  classControls: 'mx-6 b b-white rounded-full bg-white/75 flex h-11 w-11 shadow-sm center backdrop-blur <lg:hidden',
  showArrowsOnHoverOnly: true,
  sizeControls: 'md',
  titlePadding: 'mx-4 lg:mx-6',
  VfCanvasLinkedCardCollection: {
    carouselClasses: ''
  },
  VfCanvasCTAButtonCollection: {
    titleStyleClasses: 'mb-1'
  },
} satisfies RecursivePartial<CMSConfig['collection']>
